module.exports = __webpack_public_path__ + "static/media/localtion.0abdbb70.svg";